import { requireModuleUi } from '../../widgets/module-ui-catalog';
import { ModuleWorkspace } from './ModuleWorkspace';

const DEF = requireModuleUi('utm');

export default function UtmPage() {
  return <ModuleWorkspace def={DEF} hideHeader defaultTab='overview' />;
}
